import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer = (): JSX.Element => {
  const { t } = useTranslation('translation');

  return (
    <footer className="footer" id="footer">
      <div className="footer-logo-container">
        <img src="/images/logo.png" alt="武芸シザー" className="footer-logo" />
      </div>
      <div className="footer-social-divider"></div>
      <div className="footer-social">
        <a href="https://line.me/R/ti/p/@474vxczq?from=page&liff.referrer=https%3A%2F%2Fbugei-scissors.com%2F&searchId=474vxczq" target="_blank" rel="noopener noreferrer" className="social-icon">
          <img src="/images/footer/line.png" alt="Line" className="social-icon-image" />
        </a>
        <a href="https://www.instagram.com/bugei224/?locale=ja_JP" target="_blank" rel="noopener noreferrer" className="social-icon">
          <img src="/images/footer/instagram.png" alt="Instagram" className="social-icon-image" />
        </a>
        <a href="mailto:info@bugei-scissors.com" className="social-icon">
          <img src="/images/footer/mail.png" alt="Mail" className="social-icon-image" />
        </a>
      </div>
      <div className="footer-content">
        <div className="footer-section company-info">
          <h3 className="footer-title">{t('footer.company.name')}</h3>
          <p className="footer-text">{t('footer.company.postal_code')}</p>
          <p className="footer-text">{t('footer.company.address')}</p>
          <p className="footer-text" id="footer-phone">{t('footer.company.phone')}</p>
          <p className="footer-text">{t('footer.company.hours')}</p>
        </div>
        <div className="footer-section qr-codes">
          <div className="qr-code-container">
            <img src="/images/footer/line_qr.png" alt={t('footer.social.sns_1')} className="footer-qr" />
            <p className="qr-label">{t('footer.social.sns_1')}</p>
          </div>
          <div className="qr-code-container">
            <img src="/images/footer/instagram_qr.png" alt={t('footer.social.sns_2')} className="footer-qr" />
            <p className="qr-label">{t('footer.social.sns_2')}</p>
          </div>
        </div>
      </div>
      <div className="footer-copyright">
        <p className="footer-text">{t('footer.copyright')}</p>
      </div>
    </footer>
  );
};

export default Footer;